export enum TalkMediaStatus {
  Play = 'play',
  Stop = 'stop',
  Pause = 'pause',
}
